<template>
	<!-- provider di storage (Impostazioni > Storage): stesso schema delle righe di Immagini e Statistiche -->
	<div>
		<div class="sp-muted px-4 pt-3" data-tour="intro-text">
			Senza nessun provider attivo foto e file restano sullo storage di AzSeller, come sempre. Attivando il tuo, i file nuovi vanno nel tuo account; quelli già caricati restano dove sono e continuano
			a funzionare.
		</div>
		<v-data-table
			:headers="headers"
			class="elevation-0 cellanowrap"
			:hide-default-header="mobileCards"
			:class="{ 'table-cards': mobileCards }"
			hide-default-footer
			disable-pagination
			disable-sort
			data-tour="table"
		>
			<template #body>
				<!-- telefono: ogni provider diventa una card -->
				<tbody v-if="mobileCards" class="st-cards">
					<tr v-for="s in servizi" :key="s.key">
						<td :colspan="headers.length" class="px-3 py-1">
							<key-value-card>
								<template v-slot:title>
									<div class="d-flex align-center">
										<v-avatar v-for="(l, i) in s.loghi" :key="i" size="24px" tile class="mr-1"><img :src="l" :alt="s.nome" /></v-avatar>
										<span class="ml-1">{{ s.nome }}</span>
									</div>
								</template>
								<template v-slot:actions>
									<v-switch v-model="attivo[s.key]" color="primary" class="mt-0 pt-0 mr-2" hide-details :disabled="s.prossimamente" @change="cambiaAttivo(s)" />
									<v-btn small icon color="primary" :title="aperto(s) ? 'Chiudi' : 'Impostazioni'" @click="apri(s)">
										<v-icon>{{ aperto(s) ? 'mdi-minus' : 'mdi-plus' }}</v-icon>
									</v-btn>
								</template>
								<div class="sp-muted mb-2">{{ riepilogo(s) }}</div>
								<service-panel v-if="aperto(s)" :servizio="s" :modello="modello" :intestazione="false" @save="salva(s)">
									<div class="st-hint mb-3" v-html="s.istruzioni"></div>
									<template v-slot:azioni>
										<v-btn small outlined color="primary" @click="verifica"><v-icon left small>mdi-connection</v-icon>Verifica connessione</v-btn>
										<v-spacer></v-spacer>
									</template>
								</service-panel>
							</key-value-card>
						</td>
					</tr>
				</tbody>
				<tbody v-else>
					<template v-for="(s, indice) in servizi">
						<tr :key="s.key" class="as-list-row" :class="{ 'as-list-row--open': aperto(s) }" @click="apri(s)">
							<td class="pr-0" style="width: 40px">
								<v-btn small icon :data-tour="indice === 0 ? 'expand' : null" :title="aperto(s) ? 'Chiudi' : 'Impostazioni'" @click.stop="apri(s)">
									<v-icon>{{ aperto(s) ? 'mdi-minus' : 'mdi-plus' }}</v-icon>
								</v-btn>
							</td>
							<td>
								<v-avatar v-for="(l, i) in s.loghi" :key="i" size="32px" tile class="mr-1"><img :src="l" :alt="s.nome" /></v-avatar>
								<span class="ml-1">{{ s.nome }}</span>
							</td>
							<td class="sp-muted">{{ riepilogo(s) }}</td>
							<td :data-tour="indice === 0 ? 'switch' : null" @click.stop>
								<v-switch v-model="attivo[s.key]" color="primary" class="mt-0" hide-details :disabled="s.prossimamente" @change="cambiaAttivo(s)" />
							</td>
						</tr>
						<tr v-if="aperto(s)" :key="s.key + '-panel'" class="as-expanded">
							<td :colspan="headers.length" class="py-3">
								<service-panel :servizio="s" :modello="modello" :data-tour="indice === 0 ? 'settings' : null" @save="salva(s)">
									<div class="st-hint mb-3" v-html="s.istruzioni"></div>
									<template v-slot:azioni>
										<v-btn small outlined color="primary" data-tour="check" @click="verifica"><v-icon left small>mdi-connection</v-icon>Verifica connessione</v-btn>
										<v-spacer></v-spacer>
									</template>
								</service-panel>
							</td>
						</tr>
					</template>
				</tbody>
			</template>
		</v-data-table>

		<marketplace-connection-check v-model="connectionCheck.open" service="storage" :draft="connectionDraft"></marketplace-connection-check>
		<v-snackbar v-model="snackbar.open" :color="snackbar.color" multi-line :timeout="7000">
			{{ snackbar.text }}
			<v-btn dark text @click="snackbar.open = false">Chiudi</v-btn>
		</v-snackbar>
	</div>
</template>

<script>
import axios from 'axios';
import { mapGetters, mapMutations, mapActions } from 'vuex';
import KeyValueCard from '@/components/core/KeyValueCard.vue';
import ServicePanel from './ServicePanel.vue';
import MarketplaceConnectionCheck from './MarketplaceConnectionCheck.vue';

// region AWS in cui si puo' creare un bucket (quelle europee per prime)
const REGIONI_AWS = [
	['eu-south-1', 'Europa (Milano)'],
	['eu-west-1', 'Europa (Irlanda)'],
	['eu-central-1', 'Europa (Francoforte)'],
	['eu-west-3', 'Europa (Parigi)'],
	['eu-west-2', 'Europa (Londra)'],
	['eu-south-2', 'Europa (Spagna)'],
	['eu-north-1', 'Europa (Stoccolma)'],
	['eu-central-2', 'Europa (Zurigo)'],
	['us-east-1', 'Stati Uniti (Virginia del Nord)'],
	['us-east-2', 'Stati Uniti (Ohio)'],
	['us-west-1', 'Stati Uniti (California)'],
	['us-west-2', 'Stati Uniti (Oregon)'],
	['ca-central-1', 'Canada (Centrale)'],
	['sa-east-1', 'Sud America (San Paolo)'],
	['me-central-1', 'Medio Oriente (Emirati Arabi)'],
	['ap-south-1', 'Asia Pacifico (Mumbai)'],
	['ap-northeast-1', 'Asia Pacifico (Tokyo)'],
	['ap-southeast-1', 'Asia Pacifico (Singapore)'],
	['ap-southeast-2', 'Asia Pacifico (Sydney)'],
].map(([value, text]) => ({ value, text: `${text} · ${value}` }));

const vuoto = () => ({ provider: 'aws', accessKeyId: '', secretAccessKey: '', region: 'eu-south-1', bucket: '', cdnUrl: '', hasSecretAccessKey: false });

/*
 * Un solo documento Service (service: 'storage') con il provider scelto: per ora si attiva solo Amazon S3,
 * Google Cloud Storage e Azure Blob compaiono come "Disponibile a breve". Il backend prova lo storage prima
 * di accenderlo (scrittura e lettura pubblica): se la verifica non passa risponde 422 e qui si riapre il dettaglio.
 */
export default {
	name: 'StorageServices',
	components: { KeyValueCard, ServicePanel, MarketplaceConnectionCheck },
	data() {
		return {
			headers: [{ text: '' }, { text: 'Provider' }, { text: 'Stato' }, { text: 'Attivo' }],
			aperti: [],
			connectionCheck: { open: false },
			snackbar: { open: false, color: '', text: '' },
			modello: { service: 'storage', type: 'storage', active: false, setting: vuoto() },
			// interruttori delle righe: acceso solo quello del provider salvato e attivo
			attivo: { aws: false, gcs: false, azure: false },
			servizi: [
				{
					key: 'aws',
					nome: 'Amazon S3 + CloudFront',
					logo: require('@/assets/images/storage/amazon-s3.svg'),
					loghi: [require('@/assets/images/storage/amazon-s3.svg')],
					istruzioni:
						'Nel tuo account AWS crea un <b>bucket S3</b> e un <b>utente IAM</b> con i permessi <code>s3:ListBucket</code>, <code>s3:PutObject</code>, <code>s3:GetObject</code> e <code>s3:DeleteObject</code> su quel bucket, poi una sua <b>chiave di accesso</b>. ' +
						'Per servire le immagini velocemente crea una distribuzione <b>CloudFront</b> con il bucket come origine e scrivi qui il suo indirizzo. ' +
						'Prima di attivare, AzSeller carica e rilegge un file di prova: se non riesce, lo storage resta spento. ' +
						'<a href="https://www.azseller.it/documentazione/storage" target="_blank" rel="noopener">Guida passo passo</a>.',
					campi: [
						{ key: 'accessKeyId', label: 'Access Key ID' },
						{ key: 'secretAccessKey', label: 'Secret Access Key', tipo: 'password' },
						{ key: 'region', label: 'Region del bucket', tipo: 'select', items: REGIONI_AWS },
						{ key: 'bucket', label: 'Nome del bucket' },
						{ key: 'cdnUrl', label: 'Indirizzo CloudFront (es. https://d1234abcd.cloudfront.net)', pieno: true },
					],
				},
				{
					key: 'gcs',
					nome: 'Google Cloud Storage',
					logo: require('@/assets/images/storage/google-cloud-storage.svg'),
					loghi: [require('@/assets/images/storage/google-cloud-storage.svg')],
					prossimamente: true,
					campi: [],
				},
				{
					key: 'azure',
					nome: 'Azure Blob Storage',
					logo: require('@/assets/images/storage/azure-blob-storage.svg'),
					loghi: [require('@/assets/images/storage/azure-blob-storage.svg')],
					prossimamente: true,
					campi: [],
				},
			],
		};
	},
	computed: {
		...mapGetters({ getUrl: 'settings/getUrl', getToken: 'profile/getToken', getServices: 'services/getServices' }),
		mobileCards() {
			return this.$vuetify.breakpoint.width < 769;
		},
		// la verifica prova i dati del form, anche se non ancora salvati (la chiave segreta vuota = quella salvata)
		connectionDraft() {
			return { setting: { ...this.modello.setting }, active: true };
		},
	},
	async created() {
		await this.fetchService(['storage']);
		this.carica((this.getServices || []).find(s => s.service === 'storage'));
	},
	methods: {
		...mapMutations({ setPreload: 'settings/setPreload', setLogout: 'profile/setLogout' }),
		...mapActions({ fetchService: 'services/getServiceFetch', setService: 'services/updateData' }),
		carica(doc) {
			if (!doc) return;
			this.modello = { service: 'storage', type: 'storage', active: !!doc.active, setting: { ...vuoto(), ...(doc.setting || {}), secretAccessKey: '' } };
			this.allineaInterruttori();
		},
		allineaInterruttori() {
			this.attivo = { aws: false, gcs: false, azure: false, [this.modello.setting.provider || 'aws']: !!this.modello.active };
		},
		aperto(s) {
			return this.aperti.includes(s.key);
		},
		apri(s) {
			this.aperti = this.aperto(s) ? this.aperti.filter(k => k !== s.key) : [...this.aperti, s.key];
		},
		verifica() {
			this.connectionCheck.open = true;
		},
		riepilogo(s) {
			if (s.prossimamente) return 'Disponibile a breve';
			const m = this.modello;
			if (m.setting.provider !== s.key || !m.active) return m.setting.bucket ? `Disattivato · bucket ${m.setting.bucket}` : 'Disattivato · si usa lo storage di AzSeller';
			return m.setting.cdnUrl ? `Attivo · ${m.setting.bucket} via CloudFront` : `Attivo · ${m.setting.bucket}`;
		},
		cambiaAttivo(s) {
			this.modello.setting.provider = s.key;
			this.modello.active = !!this.attivo[s.key];
			this.salva(s);
		},
		async salva(s) {
			this.setPreload(true);
			try {
				this.modello.setting.provider = s.key;
				const { data } = await axios.post(`${this.getUrl}services/update`, this.modello, { headers: { Authorization: `Bearer ${this.getToken}` } });
				this.setService(data.data);
				this.carica(data.data);
				this.snackbar = {
					open: true,
					color: 'success',
					text: this.modello.active ? `${s.nome} attivo: i file nuovi vanno nel tuo bucket ${this.modello.setting.bucket}.` : 'Salvato. I file nuovi restano sullo storage di AzSeller.',
				};
			} catch (err) {
				if (err.response && err.response.status === 401) {
					this.setLogout();
					this.$router.push('/login');
					return;
				}
				const res = err.response && err.response.data;
				// verifica non superata: lo storage non e' stato acceso, si mostra cosa non va
				if (err.response && err.response.status === 422 && res && res.check) {
					this.modello.active = false;
					this.allineaInterruttori();
					if (!this.aperto(s)) this.apri(s);
					this.connectionCheck.open = true;
				}
				const errors = res && res.error;
				this.snackbar = { open: true, color: 'error', text: (Array.isArray(errors) ? errors[0] : errors) || err.message };
			} finally {
				this.setPreload(false);
			}
		},
	},
};
</script>

<style scoped>
.sp-muted {
	color: #5f6b7a;
	font-size: 13px;
}
.st-hint {
	font-size: 13px;
	color: #5f6b7a;
	line-height: 1.5;
}
.as-list-row {
	cursor: pointer;
}
.as-list-row--open,
.as-list-row--open:hover {
	background: #f3f6fa !important;
}
/* la tabella ha cellanowrap: il pannello aperto e le istruzioni vanno a capo */
.as-expanded td,
.st-hint {
	white-space: normal;
}
.as-expanded,
.as-expanded:hover {
	background: transparent !important;
}
.table-cards ::v-deep table {
	display: block;
	width: 100%;
}
.st-cards,
.st-cards tr {
	display: block;
	width: 100%;
}
.st-cards tr,
.st-cards tr:hover {
	background: transparent !important;
}
.st-cards td {
	display: block;
	width: 100%;
	border-bottom: none !important;
	height: auto !important;
}
</style>
